module.exports = __webpack_public_path__ + "hotpay.png?8c7ec30ec39217cb47d81f1503ac3b6c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/hotpay.png
// module id = 6whO
// module chunks = 46